@if (stakingProcess$ | async; as stakingProcess) {
  <ng-lottie width="120px" height="120px" [options]="successAnimationOptions"></ng-lottie>
  <div class="title">
    <span>{{
      (stakingProcess.type === stakeType
      ? "you_are_staking"
      : stakingProcess.stakeable.isLocked
      ? "you_are_unstaking"
      : "you_unstaked"
      ) | translate
    }}</span>
    <!-- For locked assets unstaking the title is always in asset -->
    @if (stakingProcess?.stakeable.isLocked && stakingProcess.type !== stakeType) {
      <span>
        {{
        stakingProcess.amountType === tradeAmountTypes.ASSET
        ? (stakingProcess.amount
        | tradable_precision_symbol
        : {
        id: stakingProcess.stakeable?.id,
        showNameInsteadOfSymbol: true
        })
        : (stakingProcess.amount
        | convert_fiat_to_tradable: stakingProcess.stakeable.id
        | tradable_precision_symbol
        : {
        id: stakingProcess.stakeable?.id,
        showNameInsteadOfSymbol: true
        })
        }}
      </span>
    }
    <!-- Flexible or regular stake -->
    @if (!stakingProcess?.stakeable.isLocked || stakingProcess.type === stakeType) {
      <span
        >{{
        stakingProcess.amountType === tradeAmountTypes.ASSET
        ? (stakingProcess.amount
        | tradable_precision_symbol
        : {
        id: stakingProcess.stakeable?.id,
        symbol: true
        })
        : (stakingProcess.amount
        | fiat_precision_symbol
        : {
        id: defaultFiat?.getId(),
        currencies: [defaultFiat],
        symbol: true
        })
        }}
        @if (stakingProcess.type === stakeType) {
          ({{
          stakingProcess.amountType === tradeAmountTypes.ASSET
          ? (stakingProcess.amount
          | convert_tradable_to_fiat: stakingProcess.stakeable?.id
          | fiat_precision_symbol
          : { id: defaultFiat.getId(), currencies: [defaultFiat], symbol: true })
          : (stakingProcess.amount
          | convert_fiat_to_tradable: stakingProcess.stakeable?.id
          | tradable_precision_symbol: { id: stakingProcess.stakeable?.id, symbol: true })
          }})
        }
      </span>
    }
  </div>
  <span class="sub">
    @if (stakingProcess.type === stakeType) {
      <!-- Specific copy for UK -->
      {{
      "uk_finprom_staking_your_first_payout"
      | translate
      : [
      stakingProcess.stakeable.nextReward.iso8601
      | date_format: { month: "long", day: "numeric", year: "numeric" }
      ]
      }}
    } @else {
      <!-- For locked assets unstaking the subtext is always in fiat -->
      @if (stakingProcess.stakeable.isLocked) {
        {{
        stakingProcess.amountType === tradeAmountTypes.ASSET
        ? ("unstaking_success_subtext_locked"
        | translate
        : [
        stakingProcess.amount
        | convert_tradable_to_fiat: stakingProcess.stakeable.id
        | fiat_precision_symbol
        : { id: defaultFiat.getId(), currencies: [defaultFiat], symbol: true }
        ])
        : ("unstaking_success_subtext_locked"
        | translate
        : [
        stakingProcess.amount
        | fiat_precision_symbol
        : { id: defaultFiat.getId(), currencies: [defaultFiat], symbol: true }
        ])
        }}
      } @else {
        <!-- Specific copy for UK -->
        {{
        "uk_finprom_unstaking_success_subtext_flexible"
        | translate
        : [
        stakingProcess.amount
        | convert_tradable_to_fiat: stakingProcess.stakeable?.id
        | fiat_precision_symbol
        : { id: defaultFiat?.getId(), currencies: [defaultFiat], symbol: true }
        ]
        }}
      }
    }
  </span>
}
